import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './configs/routes';
import Router from './providers/router';
import AppBar from './components/app-bar';
import CssBaseline from '@material-ui/core/CssBaseline';

import styles from './styles';
import Footer from 'components/footer';
import 'assets/style/bootstrap-grid.css';
import 'assets/style/bootstrap-reboot.css';
import 'assets/style/compalatepage.css';
import 'assets/style/companyprofile.css';
import 'assets/style/comparepage.css';
import 'assets/style/complete.css';
import 'assets/style/complateadminpage.css';
import 'assets/style/font.css';
import 'assets/style/icon.css';
import 'assets/style/master.css';
import 'assets/style/insurancepage.css';
import 'assets/style/responsive.css';
import Snack from 'components/Snack';
import { Toaster } from 'utils/toaster';

class App extends Component {
  componentDidCatch() {
    // window.location.href = window.location.origin;
  }

  render() {
    const { classes } = this.props;
    return (
      <BrowserRouter>
        <Toaster />

        <div className={classes.app}>
          <CssBaseline />
          <AppBar />
          <main className={classes.content}>
            <Router routes={Routes} />
            <Snack />
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

export default styles(App);
